import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IOrganizationsDAO } from '../../../../api/organizations.dao';

export class OrganizationsUploadJob extends JobConfiguration {
    public readonly type = JobType.OrganizationsUpload;
    public readonly name = 'Upload Attendees';
    public readonly description = 'Attendees Import';

    public async execute(execParams) {
        return IoC.Container.get(IOrganizationsDAO).importOrganizations(execParams);
    }
}

export default {
    [JobType.OrganizationsUpload]: OrganizationsUploadJob
};
